import React, { useCallback } from 'react';
import { Button } from '@framework-controls/core';
import { strings } from 'src/localization';
import css from './ServiceTabBtn.module.scss';
import classNames from 'classnames';
import { ButtonIds } from '../ServiceTab';

interface IProps {
    id: ButtonIds;
    label: string;
    selected: boolean;
    theme: string;
    onClick: (e: any) => void;
}

const CalendarSelectBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.calBtn,
        {
            [css.calBtnChecked]: props.selected,
            [css.calBtnCheckedCA]: props.theme === 'cadillac' && props.selected,
        },
    );

    let contentsClassName = classNames(
        css.calBtnContents,
        {
            [css.calBtnContentsChecked]: props.selected,
        },
    );
    if (props.theme === 'colorSensitive') {
        contentsClassName = classNames(
            css.calBtnContentsCS,
            {
                [css.calBtnContentsCheckedCS]: props.selected,
            },
        );
    }

    const subBtnClassName = classNames(
        css.calSubBtn,
        {
            [css.calSubBtnChecked]: props.selected,
        },
    );

    const onClick = useCallback((e: any) => {
        props.onClick(e);
    }, [props.onClick]);

    let tooltip = '';
    if (props.id === ButtonIds.MaintMenu) {
        tooltip = strings.RecomMaintTip;
    }
    if (props.id === ButtonIds.IndSvcs) {
        tooltip = strings.ViewServcTip;
    }
    if (props.id === ButtonIds.WriteYour) {
        tooltip = strings.WriteYourOwnTip;
    }

    return (
        <div className={btnClassName}>
            <div className={subBtnClassName}>
                <Button
                    id={props.id + 'Btn'}
                    onClick={(e: any) => onClick(e)}
                    variant={props.selected ? 'calBtnChecked' : 'calBtn'}
                    disableRipple
                    type={'text'}
                    tooltip={tooltip}
                >
                    <div className={css.contentsTitleDiv}>
                        <h3 className={contentsClassName}>{props.label}</h3>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default CalendarSelectBtn;